<template>
  <RichText v-model="comp" :label="label" :sublabel="$attrs.sublabel" class="field-footercontent" />
</template>

<script>
import RichText from './RichText'
import { ValueComp } from '../utils'

export default {
  props: {
    label: String,
    value: String,
  },

  computed: {
    comp: ValueComp(),
  },

  components: {
    RichText,
  },
}
</script>

<style lang="scss">
.field-renderer--footercontent {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));

  grid-gap: 2rem;
  grid-column-end: span 2;

  .field-renderer__item {
    margin-top: 0;
  }
}
</style>
